// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__15iPS","list":"BalanceDue_list__zDUrZ","listRow":"BalanceDue_listRow__1JOnK","total":"BalanceDue_total__2tfoj"};